import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ChargingStationRemoteTransactionRequest } from '@dto/chargingStationRemoteTransactionRequest';
import { TransactionDto } from '@dto/transactionDto';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { HttpState } from 'src/app/types/HttpState';

@Component({
  selector: 'app-remote-start-stop-dialog-content',
  templateUrl: './remote-start-stop-dialog-content.component.html',
  styleUrls: ['./remote-start-stop-dialog-content.component.css']
})
export class RemoteStartStopDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'RemoteStartStopDialogContentComponent';

  @Input() private chargingStation: ChargingStation;
  @Input() private chargingPointConnectorId: number = 1;
  @Input() private start: boolean;
  @Input() private transaction: TransactionDto;
  @Input() private chargingWillBeAssignedToUser: boolean;

  public state: HttpState = 'loading';

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationService: ChargingStationsService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.start) {
      var remoteStartRequest: ChargingStationRemoteTransactionRequest = {
        start: true
      }

      this.chargingStationService.remoteStartTransaction(this.chargingStation.id, this.chargingPointConnectorId).subscribe(result => {
        if (result.status == 'Accepted') {
          this.state = 'success';
        } else {
          this.state = 'failure';
        }
      }, error => {
        this.state = 'failure';
      });

    } else {
      var remoteStopRequest: ChargingStationRemoteTransactionRequest = {
        start: false
      }

      if (this.transaction == null) {
        this.chargingStationService.remoteStopTransaction(this.chargingStation.id, this.chargingPointConnectorId).subscribe(result => {
          if (result.status == 'Accepted') {
            this.state = 'success';
          } else if (result.status == 'insufficientrights') {
            this.state = 'insufficientrights';
          } else {
            this.state = 'failure';
          }
        }, error => {
          this.state = 'failure';
        });
      } else {
        this.chargingStationService.remoteStopTransactionOfTransactionId(this.transaction.chargingStationId, this.transaction.id).subscribe(result => {
          if (result.status == 'Accepted') {
            this.state = 'success';
          } else if (result.status == 'insufficientrights') {
            this.state = 'insufficientrights';
          } else {
            this.state = 'failure';
          }
        }, error => {
          this.state = 'failure';
        });
      }
    }
  }

  onConfirmClick() {
    if (this.state == 'success') {
      this.activeModal.close({ success: true });
    } else {
      this.activeModal.close({ success: false });
    }
  }
}
